import { render, staticRenderFns } from "./writing.vue?vue&type=template&id=151749b6&scoped=true"
import script from "./writing.vue?vue&type=script&lang=js"
export * from "./writing.vue?vue&type=script&lang=js"
import style0 from "./writing.vue?vue&type=style&index=0&id=151749b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151749b6",
  null
  
)

export default component.exports